'use client';
import { Suspense } from 'react';
import { useSearchParams } from 'next/navigation';
import { RequireRole } from '../../components/console-shell';
import { CaseReading } from '../../components/desk/case-reading';
import { useSession } from '../../lib/session';
function CasesContent() {
  const personId = useSearchParams().get('personId') ?? '';
  const { hasRole } = useSession();
  const role = ['PROFILE_CASE_HANDLER', 'PROFILE_CASE_REVIEWER'].find(hasRole) ?? 'PROFILE_CASE_HANDLER';
  return <RequireRole roleCode={role}><CaseReading key={personId} personId={personId} /></RequireRole>;
}
export default function CasesPage() {
  return <Suspense fallback={<p role="status">正在读取人员筛选…</p>}><CasesContent /></Suspense>;
}
